import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogPopupComponent } from '../dialog-popup/dialog-popup.component';
import { BackendApiService } from '../../app/services/backend-api.service';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms'; // Import ReactiveFormsModule
@Component({
  selector: 'app-addcallibration',
  templateUrl: './addcallibration.component.html',
  styleUrls: ['./addcallibration.component.scss'],
  standalone: true,
  imports: [
    MatTooltipModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule]
})
export class AddcallibrationComponent implements OnInit {
  
  display: string;
  readingnumber: any;
  dialogReffstart: any;
  dialogReff: any;
  public myForm: any;
  timeout: boolean;
  setTimer: any;
  showText: boolean=false;
  chancesLeft: number=1;
  lastChance: boolean=false;
  constructor(
    public dialog: MatDialog,
    private service: BackendApiService,
    public dialogRef: MatDialogRef<AddcallibrationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private formBuilder: FormBuilder,
  )
   { 
    dialogRef.disableClose=true;
    if (data.type === "DialogForManualReading") {
      console.log('call constructor')
      this.readingnumber=data.number;
      this.timer(data.configtime);
    }
   
  }

  ngOnInit() {
    this.myForm =this.formBuilder.group({
      rr1: new FormControl(),
      tr1: new FormControl(),
      ar1: new FormControl()
    });
    
  }

  timer(minute) {
    // let minute = 1;
    console.log(minute,'minnnnnnnnnnn')
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";
    console.log(seconds,'seconds')
    this.setTimer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      console.log(this.timeout,'timeout')
      if (seconds == 0 && this.timeout!=true) {
        console.log("finished");
        //this.dialogRef.close();
        //document.getElementById('plant_dashModals').style.display='none';
        if(this.chancesLeft==2){
          this.lastChance=true;
        }
        if(this.chancesLeft==3){
          console.log('this is last chance')
          this.dialogRef.close({message:"callibrationlapsed"});
          clearInterval(this.setTimer);
        }
        else{
          this.showText=true;
          this.dialogReff = this.dialog.open(DialogPopupComponent, {
            width: "300px",
            maxWidth: "100%",
            data: {
              type: "MeassagepopupDialog",
              Message:"Do you need more time?",
              choice:true
           
            },
          });
            this.dialogReff.afterClosed().subscribe(result => {
          console.log(`Dialog result: ${result}`); 
          if(result=="yes"){
            this.chancesLeft++;
            this.timer(2);
            this.showText=false;
             
            
           }
           else{
            
            this.dialogRef.close({data:{readingno:this.readingnumber,radial:null,tangential:null,axial:null} });
            clearInterval(this.setTimer);
            // this.service.showError("callibraton lapsed");
           }
            });
            // this.dialogRef.close({data:{radial:1,tangential:1,axial:1} });
            clearInterval(this.setTimer);
        } 
      }
    }, 1000);
  }



  savecallibrationdata(){
    console.log(this.myForm.value)
   
    this.timeout=true;
   this.dialogRef.close({data:{readingno:this.readingnumber,radial:this.myForm.value.rr1,tangential:this.myForm.value.tr1,axial:this.myForm.value.ar1} });
   clearInterval(this.setTimer);
  }

  onNoClick(): void {
    clearInterval(this.setTimer);
    this.dialogRef.close({message:"callibrationlapsed"});
  }

}
